import {
	ErrorChip,
	Grid,
	InfoChip,
	Label,
	Spacer,
	Text,
} from '@components';
import { SHIPMENT_EDIT_WINDOW } from '@types';
import { formatPriceToFinancial } from '@utils';
import styles from './PriceAcceptance.module.scss';

const ISSUE_AND_CLAIM_NOTICE = 'The shipper has been invoiced, so the difference will be raised as an I&C.';

export interface PriceAcceptanceProps {
	recalculated: boolean;
	newShipperPrice: number;
	isAllocated?: boolean;
	newCarrierCost?: number;
	oldShipperPrice?: number;
	oldCarrierCost?: number;
	noPriceReason?: string;
	editWindow?: SHIPMENT_EDIT_WINDOW;
}

export const PriceAcceptance = (props: PriceAcceptanceProps) => {
	const {
		recalculated,
		newShipperPrice,
		isAllocated,
		newCarrierCost = 0,
		oldShipperPrice = 0,
		oldCarrierCost = 0,
		noPriceReason = 'No price found for this range. Update rate card to proceed.',
		editWindow,
	} = props;

	/* Past the invoice the shipper's price cannot move, so the difference is raised as an I&C instead. */
	const pastShipperInvoice = editWindow === SHIPMENT_EDIT_WINDOW.ISSUE_AND_CLAIM_ADJUSTMENT;

	/* The price it was before the edit, struck through, alongside what it becomes. */
	const generatePrices = (oldPrice: number, newPrice: number) => (
		<div className={styles.prices}>
			{oldPrice > 0 && oldPrice !== newPrice && (
				<span className={styles.oldPrice}>
					<Text>${formatPriceToFinancial(`${oldPrice}`)}</Text>
				</span>
			)}
			<Text>${formatPriceToFinancial(`${newPrice}`)}</Text>
		</div>
	);

	return (
		<>
			{recalculated && (
				<>
					<Spacer size={16} />
					<Grid columns={2} gap={'4px'} columnTemplate={'130px 1fr'}>
						<Label>New Total Price</Label>
						{generatePrices(oldShipperPrice, newShipperPrice)}
					</Grid>
					{newShipperPrice === 0 && (
						<>
							<Spacer size={8} />
							<ErrorChip text={noPriceReason} stretch />
						</>
					)}
					{newShipperPrice > 0 && pastShipperInvoice && (
						<>
							<Spacer size={8} />
							<InfoChip text={ISSUE_AND_CLAIM_NOTICE} stretch />
						</>
					)}
				</>
			)}
			{/* With no cost to show, whatever offers a cost to state owns that row instead. */}
			{recalculated && isAllocated && newCarrierCost > 0 && (
				<>
					<Spacer size={4} />
					<Grid columns={2} gap={'4px'} columnTemplate={'130px 1fr'}>
						<Label>New Total Cost</Label>
						{generatePrices(oldCarrierCost, newCarrierCost)}
					</Grid>
				</>
			)}
		</>
	);
};
